import { useQuery } from '@tanstack/react-query'

import { GetFluxoPagamentosService } from '@/features/simulador/brasil/services/get-fluxo-pagamentos-simulacao.service'
import { simulacaoKeys } from '@/features/simulador/brasil/utils/queries'

export const useFluxoPagamento = (ids: string[]) => {
  return useQuery({
    queryFn: async () => {
      const response = await new GetFluxoPagamentosService().execute(ids)
      return response.data
    },
    queryKey: simulacaoKeys.fluxoDePagamento(ids),
    staleTime: 1000 * 60 * 30,
  })
}
